import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import tw from "tailwind-styled-components";
import { CARD_TYPES } from "@utils";
import { HeaderSection } from "@components";
import { clubSortingOptions } from "@redux/search/actions";
import { getHomePageSetting } from "@redux/settings/actions";

import {
  Banner,
  PlayNine,
  Traveling,
  GolfTrands,
  ExploreGame,
  FeatureCourse,
  DrivingCourse,
  TodayBestDeals,
  ExploreCountrys,
  CoursesInCountry,
  TeachingProCourse,
  PuttingGreenCourse,
  PitchingAreaCourse,
} from "./widgets";
import { Reviews } from "./widgets/reviews";

const RenderCourseCard = ({ item }) => {
  switch (item?.attributes?.section) {
    case CARD_TYPES.featured:
      return <FeatureCourse item={item} />;
    case CARD_TYPES.bestInCountry:
      return <CoursesInCountry item={item} />;
    case CARD_TYPES.todayBestDeals:
      return <TodayBestDeals item={item} />;
    case CARD_TYPES.ad:
      return <Banner item={item} />;
    case CARD_TYPES.playNine:
      return <PlayNine item={item} />;
    case CARD_TYPES.drivingRange:
      return <DrivingCourse item={item} />;
    case CARD_TYPES.puttingGreen:
      return <PuttingGreenCourse item={item} />;
    case CARD_TYPES.teachingPro:
      return <TeachingProCourse item={item} />;
    case CARD_TYPES.pitchingArea:
      return <PitchingAreaCourse item={item} />;
    case CARD_TYPES.latestArticlesAndTips:
      return <GolfTrands item={item} />;
    case CARD_TYPES.exploreGame:
      return <ExploreGame item={item} />;
    case CARD_TYPES.exploreByCountries:
      return <ExploreCountrys item={item} />;
    case CARD_TYPES.travelingDestinations:
      return <Traveling item={item} />;
    default:
      return null;
  }
};

const Home = () => {
  const dispatch = useDispatch();
  const { homePageSetting } = useSelector((store) => store.settingsReducer);
  const { logo } = useSelector((store) => store.headerReducer);
  const headerImg =
    logo?.data && logo?.data?.attributes?.bgImage?.data[0]?.attributes?.url;

  useEffect(() => {
    dispatch(getHomePageSetting());
    dispatch(clubSortingOptions());
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <HeaderSection headerImage={headerImg} isCompact={false} />
      {homePageSetting?.map((item) => (
        <RenderCourseCard item={item} />
      ))}
      {/* <Reviews /> */}
    </Container>
  );
};

const Container = tw.div`
bg-[#f9f9f9]
`;

export default Home;
